/**
 * <CategoryVars/> — r7.6.4: publishes every category's colour as `--snt-cat-<slug>` on <html>, re-applied when the
 * taxonomy loads or the theme mode flips. Renders nothing.
 */
import { useEffect } from 'react';
import { useThemeOptional } from '@/themes/ThemeContext';
import { useCategories, applyCategoryVars } from '@/lib/taxonomy';

export function CategoryVars() {
  const { categories } = useCategories();
  const mode = useThemeOptional()?.activeMode || 'dark';   // r7.8: no provider outside the app shell
  useEffect(() => { applyCategoryVars(categories, mode); }, [categories, mode]);
  return null;
}
export default CategoryVars;
